import { environment } from '../../environments/environment';

export class ApiUrlConstant {
    static readonly apiUrl = environment.api;
    static readonly examUrl = environment.api1;
    static readonly cmsrUrl = environment.CMS_API;
    static readonly cyotUrl = environment.cyotdevApi;
    //static readonly subjectUrl = environment.api2;
    static readonly newApiUrl = environment.apiNew;
    static readonly omsdevapi = environment.omsdevapi;
    static readonly uafapi = environment.uafapi;
    static readonly usersapi = environment.usersapi;
    static readonly ePragnaUrl = environment.ePragnaUrl;
    static readonly LIVE_CLASS_API = environment.LIVE_CLASS_API;
    static readonly dcapi = environment.dcapi;
    static readonly messages=environment.messages;
    static readonly status=environment.status;
    static readonly dsrapi = environment.dsrapi;
    static readonly myActivity = environment.myActivity_url;
    static readonly selfLearn = environment.SELF_LEARN_API;
    static readonly self_learn_api = environment.SELF_LEARN_API;
    static readonly stageeosapi = environment.stageeosapi;
    static readonly LEARN_BE_EVENT_API = environment.LEARN_BE_EVENT_API;
    

}
